<template>
  <!-- Search Filter -->
  <div class="row filter-row">
    <div class="col-sm-6 col-md-3">
      <div class="input-block mb-3 form-focus focused"> 
        <!-- <input
          type="text"
          class="form-control floating"
          v-model="search.employee_name"
          @focus="isFocused = true"
          @blur="isFocused = name !== ''"
          @keyup.enter="searchAsset"
        /> -->
        <vue-select
          :options="employee_list_dd"
          id="assetEmployeeSearch"
          v-model="search.employee_name"
          placeholder="-"
        />
        <label class="focus-label">Employee Name</label>
      </div>
    </div>
    <!-- <div class="col-sm-6 col-md-3">
      <div class="input-block mb-3 form-focus select-focus">
        <vue-select :options="assets" id="assets" placeholder="-- Select --" />
        <label class="focus-label">Status</label>
      </div>
    </div> -->
    <div class="col-sm-12 col-md-4">
      <div class="row">
        <div class="col-md-6 col-sm-6">
          <div class="input-block mb-3 form-focus">
            <div class="cal-icon">
              <datepicker
                v-model="startdate"
                placeholder="From"
                class="form-control floating datetimepicker"
                :editable="true"
                :clearable="false"
                :input-format="dateFormat"
                @update:model-value="searchAsset"
              />
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-6">
          <div class="input-block mb-3 form-focus">
            <div class="cal-icon">
              <datepicker
                v-model="startdateone"
                placeholder="To"
                class="form-control floating datetimepicker"
                :editable="true"
                :clearable="false"
                :input-format="dateFormat"
                @update:model-value="searchAsset"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-md-2">
      <div class="d-grid">
        <a
          href="javascript:;"
          class="btn btn-success mb-3 submit-btn"
          @click="searchAsset()"
        >
          Search
        </a>
      </div>
    </div>
    <div class="col-sm-6 col-md-2">
      <div class="d-grid">
        <a
          href="javascript:;"
          class="btn btn-danger submit-btn"
          @click="clerSearchAsset()"
        >
          Clear
        </a>
      </div>
    </div>
  </div>
  <!-- /Search Filter -->
</template>
<script>
import { ref } from "vue";
import { notification } from "ant-design-vue";
import axios from "axios";
const currentDate = ref(new Date());
const currentDateOne = ref(new Date());
export default {
  emits: ["search-asset"],
  data() {
    return {
      select2: null,
      assets: ["-- Select --", "Pending", "Approved", "Returned"],
      startdate: null,
      startdateone: null,
      dateFormat: "dd-MM-yyyy",
      name: "",
      isFocused: false,
      search: {
        employee_name: "",
        start_date: "",
        end_date: "",
      },
      employee_list_dd: [],
    };
  },
  methods: {
    clerSearchAsset() {
      this.startdate = null;
      this.startdateone = null;
      this.search.employee_name = "";

      this.$emit("search-asset", null);
    },
    searchAsset() {
      let formData = {};

      if (this?.search?.employee_name != "") {
        formData.employee_name = this?.search?.employee_name;
      }

      if (this?.startdate != "" && this?.startdate != null) {
        if (!isNaN(this.startdate.getTime())) {
          var dd = this.startdate;
          dd.setMonth(dd.getMonth() + 1);

          const year = dd.getFullYear();
          const month = dd.getMonth().toString().padStart(2, "0");
          const day = dd.getDate().toString().padStart(2, "0");
          formData.start_date = `${year}-${month}-${day}`;
        }
      }

      if (this?.startdateone != "" && this?.startdateone != null) {
        if (!isNaN(this.startdateone.getTime())) {
          var dd = this.startdateone;
          dd.setMonth(dd.getMonth() + 1);

          const year = dd.getFullYear();
          const month = dd.getMonth().toString().padStart(2, "0");
          const day = dd.getDate().toString().padStart(2, "0");
          formData.end_date = `${year}-${month}-${day}`;
        }
      }

      this.$emit("search-asset", formData);
    },
    loadAllEmployee() {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      axios
        .get("/employees/all")
        .then((response) => {
          this.employee_list_dd = [];

          for (let i = 0; i < response?.data?.data.length; i++) {
            this.employee_list_dd.push({
              id: response.data.data[i].id,
              text:
                response.data.data[i].first_name +
                " " +
                response.data.data[i].last_name,
            });
          }
        })
        .catch((error) => {
          console.log("error", error);
          var response = error.response;

          if (
            error.response?.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
  },
  created() {
    this.startdate = null;
    this.startdateone = null;
    this.search.employee_name = "";
    this.loadAllEmployee();
  },
};
</script>
